<template>
    <div class="userinfo">
      <div class="content">
          <div class="tip">
            {{getUserInfo.username}} 您好！您是第一次上传作品，请补充参赛信息，谢谢！
          </div>
          <div class="userinfo">
              <div class="tab" :class="{ 'active': activeTab == '志愿者'}"  v-on:click="changeTab('志愿者')">志愿者</div>
              <div class="tab rightTab" :class="{ 'active': activeTab == '非志愿者'}" v-on:click="changeTab('非志愿者')">非志愿者</div>
              <div class="line"></div>
              <el-form :model="infoForm" ref="infoForm" :rules="rules" label-width="120px" class="ruleForm">
                <el-form-item
                    size="small"
                    label="姓名"
                    prop="realname"
                    :rules="[
                    { required: true, message: '姓名不能为空'},
                    ]"
                >
                    <el-input type="realname" v-model="infoForm.realname"  autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="性别"
                    prop="gender"
                    :rules="[
                    { required: true, message: '请选择性别'},
                    ]"
                >
                    <el-radio-group  v-model="infoForm.gender" size="small">
                        <el-radio  label="1">男</el-radio>
                        <el-radio  label="2">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="所在国家"
                    prop="country"
                    :rules="[
                    { required: true, message: '请选择所在国家'},
                    ]"
                >
                    <el-select v-model="infoForm.country" @change="countryChange">
                    <el-option v-for="(value, key, index) in countryList"  v-bind:key="index"  :label="value.cn" :value="value.skey"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item
                    v-if="activeTab == '志愿者'"
                    size="small"
                    label="任教学校"
                    prop="school"
                    :rules="[
                    { required: activeTab == '志愿者', message: '任教学校不能为空'},
                    ]"
                >

                    <el-select v-model="infoForm.school" no-data-text="请先选择所在国家">
                    <el-option v-for="(value, key, index) in schoolList"  v-bind:key="index"  :label="value.name" :value="value.val"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item
                    v-if="activeTab == '志愿者'"
                    size="small"
                    label="任教学校"
                    prop="school"
                    :rules="[
                    { required: activeTab == '志愿者', message: '任教学校不能为空'},
                    ]"
                >
                    <el-input type="school" v-model="infoForm.school"  autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item 
                    v-if="activeTab == '志愿者'"
                    size="small"
                    label="开始时间"
                    prop="appoint_time"
                    :rules="[
                    { required: activeTab == '志愿者', message: '赴任时间不能为空'},
                    ]"
                
                >
                    <el-col>
                    <el-date-picker type="month" :editable="false" placeholder="选择日期" v-model="infoForm.appoint_time" 
                    format="yyyy 年 MM 月" :clearable='false'
                    style="width: 100%" ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item 
                    v-if="activeTab == '志愿者'"
                    size="small"
                    label="结束时间"
                    prop="quit_time"
                    :rules="[
                    { required: activeTab == '志愿者', message: '离任时间不能为空'},
                    ]"
                >
                    <el-col>
                    <el-date-picker type="month" :editable="false" placeholder="选择日期" v-model="infoForm.quit_time" 
                    format="yyyy 年 MM 月" :clearable='false'
                    style="width: 100%;" ></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item
                    v-if="activeTab == '非志愿者'"
                    size="small"
                    label="工作单位"
                    prop="work"
                    :rules="[
                    { required: activeTab == '非志愿者', message: '工作单位不能为空'},
                    ]"
                >
                    <el-input type="workplace" v-model="infoForm.work"  autocomplete="off"></el-input>
                </el-form-item>
                                <el-form-item
                    size="small"
                    label="电子邮件"
                    prop="email"
                    :rules="[
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                    ]"
                >
                    <el-input  v-model="infoForm.email"  autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="电话"
                    prop="checkPhone1"
                >
                    <el-input type="remote_phone" v-model="infoForm.phone_number"  autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="QQ"
                    prop="checkQQ"
                >
                    <el-input type="qq" v-model="infoForm.qq"  autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="微信"
                    prop="checkQQ"
                >
                    <el-input type="qq" v-model="infoForm.wechat"  autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item
                    size="small"
                    label="备注"
                >
                    <el-input  type="textarea" v-model="infoForm.remark"  autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
              <el-button type="primary" size="medium" class="submitBtn" @click="submitForm('infoForm')">报名</el-button>
          </div>
      </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'userinfo',
    data: function () {
        var validateEmail = (rule, value, callback) => {
          var reg =  /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/
          setTimeout(() => {
              if(this.infoForm.email == ''){
                  callback(new Error('请填写邮箱'));
              }else if (!(reg.test(this.infoForm.email))) {
                  callback(new Error('请输入正确的邮箱'));
              }else {
                  callback();
              }
          }, 500)

      };
      var validatePhone1 = (rule, value, callback) => {
          setTimeout(() => {
              if(this.infoForm.remote_phone == ''){
                  callback();
              }else {
                  callback();
              }
          }, 500)

      };
      var validateQQ = (rule, value, callback) => {
          setTimeout(() => {
              if(this.infoForm.qq == ''){
                  callback();
              }else if (!Number.isInteger(Number(this.infoForm.qq))) {
                  callback(new Error('请输入数字'));
              }else {
                  callback();
              }
          }, 500)

      };
        return {
            countryList: [],
            schoolList: [],
            activeTab: '志愿者',
            infoForm: {
              user_type: 1, // 1：志愿者 0：非志愿者
              realname: '',
              gender: undefined,
              country: undefined,
              school: null,
              appoint_time: '',
              quit_time: '',
              email: '',
              work: '',
              phone_number: '',
              qq: '',
              wechat: '',
              remark: '',
            },
            rules: {
            checkEmail:[
                { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
            ],
            checkPhone1: [
                { validator: validatePhone1, trigger: 'blur' }
            ],
            checkQQ: [
                { validator: validateQQ, trigger: 'blur' }
            ]
          },
        }
    },
    computed: {
    ...mapGetters(['getUserInfo']),
    },
    mounted() {
      this.getCountryList()
    },
    methods: {
      ...mapActions(['setUserInfoAction']),
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let dataForm = {}
            for (var index in this.infoForm){
              dataForm[index] = this.infoForm[index]
            }
            if(dataForm.user_type == 1) {
              delete dataForm.work
            } else {
              delete dataForm.school
              delete dataForm.appoint_time
              delete dataForm.quit_time
            }
            console.log(dataForm)
            this.$utils.postForm('/user/update-info', dataForm).then(res => {
              if(res.code == 1000) {
                this.$message({
                  message: '报名成功！',
                  type: 'success'
                });
                this.setUserInfoAction({
                    isLogin: true,
                    username: this.getUserInfo.username,
                    volunteer_info: 1
                })
                this.$router.push({
                    path: '/pcpage/submitlist/submit',
                })
              } else {
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            })
          } else {
            return false
          }
        })
      },
      // 根据国家获取孔院列表
      countryChange (country_id) {
        if(country_id){
            this.$utils.get('/user/get-institute-list',{
                state_code:country_id
            })
            .then(res => {
                res.data.list.forEach(element => {
                    this.schoolList.push({
                        val: element.cn_name,
                        name: element.cn_name
                    })
                })
                this.schoolList.push({
                val: '其它',
                name: '其它'
                })
            })
        }
      },
      // 登录
    loginFun () {
        const currentUrl = 'https://collection2021.chineseplus.net'
        window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + currentUrl
    },
    getCountryList() {
    this.$utils.get('/user/get-country-list').then(res => {
        console.log(res)
        this.countryList = res.data
        if(res.code == 1002) {
            this.loginFun()
        }
        })
    },
      // 切换tab
    changeTab (name) {
        if(this.activeTab !== name) {
            this.activeTab = name
            this.$refs.infoForm.clearValidate()
            if(this.activeTab == '志愿者'){
                this.infoForm.user_type = 1
            }else {
                this.infoForm.user_type = 0
            }
        }
    },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.userinfo {
    width: 1200px;
    margin: 50px auto;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .content {
      width: 720px;
      padding: 31px 51px;
      margin: auto;
      background-color: rgba(#fff, 0.8);
      .tip {
        font-size: 17px;
        color: #ca3c39;
        text-align: center;
      }
      .userinfo {
        width: 490px;
        text-align: center;
        .tab {
          width: 100px;
          height: 38px;
          display: inline-block;
          text-align: center;
          line-height: 38px;
          border-bottom: 1px solid #ccc;
          cursor: pointer;
          box-sizing: border-box;
        }
        .rightTab {
          width: 380px;
          text-align: left;
          padding-left: 40px;
          box-sizing: border-box;
        }
        .line {
            width: 0px;
            display: inline-block;
            border-bottom: 1px solid #ccc;
            vertical-align: bottom;
        }
        .active {
            border: 1px solid #ccc;
            border-bottom: none;
            font-weight: bold;
            
        }
        .ruleForm {
          margin-top: 40px;
          text-align: left;
        }
        .submitBtn {
          width: 100px;
          margin: auto;
        }
      }
    }
}
</style>
